import { useMutation } from '@tanstack/react-query';
import { SettingsApi } from '../settingsApi';

/**
 * This function invokes API to record feedback dismissal.
 */
export const recordFeedbackDismissal = () =>
  SettingsApi.recordFeedbackDismissal();

/**
 * React query wrapper to record feedback dismissal.
 */
export const useFeedbackDismissalMutation = () =>
  useMutation({
    mutationFn: recordFeedbackDismissal,
  });
